import {
  Component,
  OnDestroy,
  ChangeDetectionStrategy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';

import * as fromAnalytics from '../reducers';
import * as funnelActions from '../actions/funnel';
import * as referralsActions from '../actions/referrals';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mj-view-analytics-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <mj-selected-analytics></mj-selected-analytics>
  `,
  styles: [
    `
      mj-selected-analytics-page {
        display: flex;
      }
    `,
  ],
})
export class AnalyticsViewPageComponent implements OnDestroy, OnInit {
  actionsSubscription: Subscription;
  id: number;

  constructor(
    private store: Store<fromAnalytics.State>,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.actionsSubscription = this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      if (!this.id) {
        const routeArr = this.router.url.split('/');
        this.id = Number(routeArr[routeArr.length - 2]);
      }
      this.initForm();
    });
  }

  ngOnDestroy() {
    this.actionsSubscription.unsubscribe();
  }

  initForm() {
    this.store.dispatch(new funnelActions.FunnelClearErrors());
    this.store.dispatch(new referralsActions.ReferralsClearErrors());
    this.store.dispatch(new funnelActions.LoadFunnel({ id: this.id }));
    this.store.dispatch(new referralsActions.LoadReferrals({ id: this.id }));
  }
}
